import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemesService } from '../../../core/services/themes.service';
import { CssThemes } from '../../common';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent implements OnInit {
  currentTheme: CssThemes = this.themesService.currentTheme;
  CssThemes = CssThemes;
  
  constructor(private themesService: ThemesService) { }

  ngOnInit(): void {
  }

}
